// extracted by mini-css-extract-plugin
export var infoItem = "_jj-1";
export var title = "_jj-0";